import { useEffect, useRef } from "react";
export default function useDidMount() {
  var ref = useRef(false);
  useEffect(function () {
    ref.current = true;
  }, []);
  return ref.current;
}